import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckCircle2Icon, ClockIcon, HelpCircleIcon, MailIcon, PhoneIcon, ShoppingBagIcon, SparklesIcon, StarIcon, TrophyIcon } from 'lucide-react';
import { SocialIcon } from './SocialIcon';
import { CHAMPION_SHIRT_PATH } from '../../data/site';
import { championEmail, emailConfetti, emailFooterLinks, emailProductDetails, emailSocials } from '../../data/email';
const ctaClass = 'inline-flex items-center justify-center gap-3 rounded-lg bg-[#0B6CF0] font-semibold text-white shadow-[0_2px_0_#0752B8] transition-colors duration-150 hover:bg-[#095FD6]';
export function ChampionEmail() {
  return <div className="mx-auto w-full max-w-[640px] overflow-hidden rounded-b-xl border border-gray-200 bg-[#F8F9FB] text-[#14141F]" data-id="element-76" data-mp="28sek0eojp5st">
      {/* Header */}
      <header className="flex justify-center border-b border-gray-200 px-8 py-6" data-id="element-77" data-mp="ehrb22kh2zja">
        <img src={championEmail.logo} alt="i9 Sports" className="h-14 w-auto" data-id="element-78" data-mp="9ieq5nd5w2jc" />
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden border-b border-gray-200 px-8 py-10 text-center sm:px-14" data-id="element-79" data-mp="x4suyab58yue">
        <div className="pointer-events-none absolute inset-0" aria-hidden data-id="element-80" data-mp="1165zmh2i2vzq">
          {emailConfetti.map((c, i) => c.kind === 'star' ? <StarIcon key={i} className="absolute fill-gold text-gold" style={{
          left: c.left,
          top: c.top,
          width: c.size,
          height: c.size,
          transform: `rotate(${c.rotate}deg)`
        }} data-id="element-81" data-mp="1auwcinz2w4di" /> : <span key={i} className="absolute rounded-full" style={{
          left: c.left,
          top: c.top,
          width: c.size,
          height: c.size,
          backgroundColor: c.color
        }} data-id="element-82" data-mp="1kriwlajkyreh" />)}
        </div>
        <div className="relative" data-id="element-83" data-mp="3qn3q7ws0af8r">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold/35 px-4 py-1.5 text-[13px] font-semibold uppercase text-[#14141F]" data-id="element-84" data-mp="3qnvboerw2wlb">
            <TrophyIcon className="h-4 w-4 text-[#0B6CF0]" aria-hidden data-id="element-85" data-mp="12qn3pb8t2jpc" />
            Official Commemorative Edition
            <SparklesIcon className="h-4 w-4 text-[#0B6CF0]" aria-hidden data-id="element-86" data-mp="xslo50al92im" />
          </span>
          <h1 className="mt-5 text-[38px] font-bold leading-tight tracking-tight sm:text-[44px]" data-id="element-87" data-mp="1bs4k6uq4knek">Your Player Is a Champion!</h1>
          <p className="mx-auto mt-4 max-w-[480px] text-lg leading-relaxed text-gray-500" data-id="element-88" data-mp="16rqn27q2axvb">
            Congratulations on an incredible season. Celebrate the win with an official Championship Winner shirt, available for a limited time.
          </p>
          <Link to={CHAMPION_SHIRT_PATH} className={`${ctaClass} mt-7 px-10 py-4 text-lg`} data-id="element-89" data-mp="1ui30fy42tmta">
            <ShoppingBagIcon className="h-5 w-5" aria-hidden data-id="element-90" data-mp="1ujxfwwwkwmpz" />
            Shop Championship Shirt
            <ArrowRightIcon className="h-5 w-5" aria-hidden data-id="element-91" data-mp="1qivdk77d7ujs" />
          </Link>
          <p className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-92" data-mp="24gjz7h99b5pw">
            <ClockIcon className="h-4 w-4 text-gold-dark" aria-hidden data-id="element-93" data-mp="1zj0jse0tomwd" /> Limited Time Offer
          </p>
        </div>
      </section>

      {/* Product */}
      <section className="border-b border-gray-200 px-8 py-9" data-id="element-94" data-mp="2o2loocpof633">
        <span className="inline-block rounded-full bg-gold/35 px-3 py-1 text-xs font-semibold uppercase" data-id="element-95" data-mp="2nzpumzgy91jx">Featured Apparel</span>
        <h2 className="mt-3 text-[28px] font-bold leading-tight tracking-tight" data-id="element-96" data-mp="2e3d0k0hhslon">Official Championship Winner Shirt</h2>
        <div className="mt-5 grid gap-7 sm:grid-cols-2 sm:items-start" data-id="element-97" data-mp="20bgby6f18tx0">
          <div className="relative overflow-hidden rounded-xl border border-gray-200 bg-white" data-id="element-98" data-mp="252y3y4z2vk5u">
            <img src={championEmail.shirtImage} alt="Official Championship Winner Shirt in navy and athletic gold" className="aspect-square w-full object-cover" data-id="element-99" data-mp="1qek31zl825rx" />
            <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full border border-go/30 bg-[#E9F7EF] px-2.5 py-1 text-xs font-medium text-go" data-id="element-100" data-mp="1vdocmrc265is">
              <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden data-id="element-101" data-mp="1ldxe8ekdn6df" /> In Stock
            </span>
          </div>
          <div data-id="element-102" data-mp="1ebhfh89mps2f">
            <p className="text-[40px] font-bold leading-none tracking-tight" data-id="element-103" data-mp="1ee3jwz183rgf">$24.99</p>
            <Link to={CHAMPION_SHIRT_PATH} className={`${ctaClass} mt-6 w-full px-4 py-4 text-base`} data-id="element-104" data-mp="19dpn6d52o3xp">
              <ShoppingBagIcon className="h-5 w-5" aria-hidden data-id="element-105" data-mp="14kees7km3f3o" />
              Shop Championship Shirt
            </Link>
            <dl className="mt-6 space-y-1.5 border-t border-gray-200 pt-5 text-[15px] text-gray-500" data-id="element-106" data-mp="zla2v96az39n">
              {emailProductDetails.map(d => <div key={d.label} className="flex gap-1.5" data-id="element-107" data-mp="qln28plee1hn">
                  <dt data-id="element-108" data-mp="ln3ecjn8ufmn">{d.label}:</dt>
                  <dd data-id="element-109" data-mp="lo4qysjwra6h">{d.value}</dd>
                </div>)}
            </dl>
          </div>
        </div>
      </section>

      {/* Support */}
      <section className="flex flex-col gap-5 border-b border-gray-200 px-8 py-7 sm:flex-row sm:items-center" data-id="element-110" data-mp="2g1e18mka2zps">
        <div className="flex flex-1 items-center gap-4" data-id="element-111" data-mp="2b1rqqkvu3xko">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#E3EEFD] text-[#0B6CF0]" aria-hidden data-id="element-112" data-mp="2b32wurcr5hey">
            <HelpCircleIcon className="h-6 w-6" data-id="element-113" data-mp="2nknfou7n5olp" />
          </span>
          <div data-id="element-114" data-mp="2niss184zjidx">
            <h2 className="font-semibold" data-id="element-115" data-mp="2sblvztsmqmoy">Need Help with Your Championship Order?</h2>
            <p className="text-sm text-gray-500" data-id="element-116" data-mp="2sdou713xrm4r">Our customer experience team is here to help.</p>
          </div>
        </div>
        <div className="flex gap-3" data-id="element-117" data-mp="20kpkawib2o39">
          <a href="#" onClick={e => e.preventDefault()} className="flex items-center gap-2 whitespace-nowrap rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium transition-colors duration-150 hover:border-gray-400" data-id="element-118" data-mp="20lr5vuwy6sz8">
            <MailIcon className="h-4 w-4" aria-hidden data-id="element-119" data-mp="29ngwwzmx3pwh" /> Email Support
          </a>
          <a href="#" onClick={e => e.preventDefault()} className="flex items-center gap-2 whitespace-nowrap rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium transition-colors duration-150 hover:border-gray-400" data-id="element-120" data-mp="2ei4cg8zy19yx">
            <PhoneIcon className="h-4 w-4" aria-hidden data-id="element-121" data-mp="30ap7f6t9h7kk" /> Call Us
          </a>
        </div>
      </section>

      {/* Social + footer */}
      <section className="px-8 pb-8 pt-7 text-center" data-id="element-122" data-mp="2vbm2dmda71cl">
        <p className="flex flex-wrap items-center justify-center gap-3 text-[15px]" data-id="element-123" data-mp="3a94riptvfgkk">
          <span className="rounded-full bg-gold/35 px-4 py-1 font-semibold" data-id="element-124" data-mp="35abkng93antd">#i9SportsChamps</span>
          Share your team's victory moments with us!
        </p>
        <div className="mt-4 flex justify-center gap-3" data-id="element-125" data-mp="2hl8xjsvos2rh">
          {emailSocials.map(s => <SocialIcon key={s} network={s} data-id="element-126" data-mp="2cn7cx3im3vdw" />)}
        </div>

        <footer className="mt-7 border-t border-gray-200 pt-6 text-sm leading-relaxed text-gray-500" data-id="element-127" data-mp="2rashl1v4y2nx">
          <p className="font-semibold text-[#14141F]" data-id="element-128" data-mp="2misjleymljtz">i9 Sports</p>
          <p data-id="element-129" data-mp="1ytzkj9mpivv5">9410 Camden Field Parkway</p>
          <p data-id="element-130" data-mp="1ysy6qxeb3v9q">Riverview, Florida 33578</p>
          <p className="mt-2" data-id="element-131" data-mp="1yrwkrxvr5od8">© 2026 i9 Sports LLC. All rights reserved.</p>
          <p className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[13px]" data-id="element-132" data-mp="1tuwdxkr2whl2">
            {emailFooterLinks.map((l, i) => <React.Fragment key={l} data-id="element-133" data-mp="e3ke70lvc5qu" data-mpi={i}>
                {i > 0 && <span className="text-gray-300" aria-hidden data-id="element-134" data-mp="e5f0ai8vm3wi">|</span>}
                <a href="#" onClick={e => e.preventDefault()} className="transition-colors duration-150 hover:text-[#14141F] hover:underline" data-id="element-135" data-mp="3vl3lcj29cc4m">{l}</a>
              </React.Fragment>)}
          </p>
        </footer>
      </section>
    </div>;
}